import React, { useCallback } from 'react';

import { useSpdCore } from '../../../common/hooks/useSpdCore';

import { CardsSearch } from './CardsSearch';

export const CardsList: React.FC = () => {
  const spd = useSpdCore();

  const handleClick = async (id: string) => {
    await spd.cards.get(id);
  };

  const getData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.cards.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ),
    [spd.cards],
  );

  return (
    <>
      <CardsSearch
        getData={getData}
        getCount={spd.cards.getAllCount}
        onRowClick={handleClick}
        withFilterInColumns={true}
      />
    </>
  );
};
